import { Link } from "react-router-dom";
import Reveal from "./Reveal";

export default function CTA() {
  return (
    <section className="cta-wrap section-pad">
      <div className="shell">
        <Reveal>
          <div className="cta-panel">
            <div className="cta-glow" />
            <div>
              <span className="eyebrow light"><i />Your next product starts here</span>
              <h2>Have an idea, a roadmap, or a delivery challenge?</h2>
              <p>Bring us the context. We’ll help you shape the right engineering approach and move it forward.</p>
            </div>
            <Link to="/contact" className="btn btn-light">Start a conversation <span>↗</span></Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
